const spaceMultiplier = 4;

export const space = {
  xxxs: `${spaceMultiplier / 2}px`, // 2px
  xxs: `${spaceMultiplier * 1}px`, // 4px
  xs: `${spaceMultiplier * 2}px`, // 8px
  s: `${spaceMultiplier * 3}px`, // 12px
  m: `${spaceMultiplier * 4}px`, // 16px
  l: `${spaceMultiplier * 6}px`, // 24px
  xl: `${spaceMultiplier * 8}px`, // 32px
  xxl: `${spaceMultiplier * 12}px`, // 48px
  xxxl: `${spaceMultiplier * 18}px`, // 72px
};
